module.exports = __webpack_public_path__ + "img/share.cae92411.svg";